import {
  CheckboxFieldReduxFormWrapper,
  Text,
  StandardFieldLabel,
} from '@adc/ui-adc'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import React from 'react'
import { Field } from 'redux-form'
import classnames from 'classnames/bind'
import styles from './styles.scss'

const cx = classnames.bind(styles)

const MoreFiltersContent = ({
  submitForms,
  leasebackRequiredFilterEnabled,
}) => (
  <section data-elm-id='more_filters'>
    <section className='u-mb-3'>
      <h4>Hide properties that:</h4>
      <Field
        compact
        type='checkbox'
        name='hide_ending_soon'
        elmId='more_filters_ending_soon'
        onChange={submitForms}
        label={
          <StandardFieldLabel
            label='Auction ends soon'
            subLabel='Ending in the next five days'
          />
        }
        component={CheckboxFieldReduxFormWrapper}
      />
      {leasebackRequiredFilterEnabled && (
        <Field
          compact
          type='checkbox'
          name='leaseback_required'
          elmId='leaseback_required'
          onChange={submitForms}
          label={<StandardFieldLabel label='Rentback is Required' />}
          component={CheckboxFieldReduxFormWrapper}
        />
      )}
    </section>

    <section>
      <h4>Show only properties that have/are:</h4>
      <Field
        compact
        type='checkbox'
        name='listing_type'
        elmId='more_filters_listing_type'
        onChange={submitForms}
        label='Sold, Pending, or Canceled'
        component={CheckboxFieldReduxFormWrapper}
      />

      <Field
        compact
        type='checkbox'
        name='broker_coop_available'
        elmId='more_filters_broker_coop_available'
        onChange={submitForms}
        label='Broker Co-op'
        component={CheckboxFieldReduxFormWrapper}
      />

      <Field
        compact
        type='checkbox'
        name='show_reserve'
        elmId='more_filters_show_reserve'
        onChange={submitForms}
        label='Reserve Disclosed'
        component={CheckboxFieldReduxFormWrapper}
      />

      <Field
        compact
        type='checkbox'
        name='no_buyer_premium_filter'
        elmId='more_filters_no_buyer_premium_filter'
        onChange={submitForms}
        label="No Buyer's Premium"
        component={CheckboxFieldReduxFormWrapper}
      />
      <Field
        compact
        type='checkbox'
        name='presale'
        elmId='more_filters_mao_filter'
        onChange={submitForms}
        label={
          <StandardFieldLabel
            label='First Look'
            subLabel={
              <>
                <div className={cx('sub-label-spacer')} />
                <Text size='tiny' color='grayMedium'>
                  Learn More:{' '}
                  <a
                    target='blank'
                    data-elm-id='more_filters_first_look_link'
                    href='/firstlook'
                  >
                    View First Look FAQ’s
                  </a>
                </Text>
              </>
            }
          />
        }
        component={CheckboxFieldReduxFormWrapper}
      />
    </section>
  </section>
)

MoreFiltersContent.propTypes = {
  submitForms: PropTypes.func.isRequired,
  leasebackRequiredFilterEnabled: PropTypes.bool.isRequired,
}

export default connect()(MoreFiltersContent)
